/* HB 2027 — panier tiroir (livraison offerte + suggestions) et menu mobile plein écran */
(function () {
  var C = window.HB_UI || {}, K = document.getElementById('hbk'), M = document.getElementById('hbm');
  if (!K) return;
  var reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var body = K.querySelector('[data-hbk-body]'), foot = K.querySelector('[data-hbk-foot]');
  var root = C.root || '/';

  function money(c) {
    var f = C.mf || '{{amount_with_comma_separator}} €', a = (c / 100).toFixed(2);
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k.indexOf('no_decimals') > -1) a = Math.round(c / 100).toString();
      if (k.indexOf('comma') > -1) a = a.replace('.', ',');
      return a.replace(/\B(?=(\d{3})+(?!\d))/g, k.indexOf('comma') > -1 ? '.' : ',');
    }).replace(/<[^>]+>/g, '');
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
  function img(u, w) { if (!u) return ''; u = u.indexOf('//') === 0 ? 'https:' + u : u; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  var nativeFetch = window.fetch.bind(window);
  function json(url, opt) { return nativeFetch(url, opt).then(function (r) { return r.json(); }); }

  /* ---------- Ouverture / fermeture ---------- */
  var lastFocus = null;
  function lock(on) { document.documentElement.style.overflow = on ? 'hidden' : ''; }
  function open(el) {
    lastFocus = document.activeElement; el.hidden = false; lock(true);
    void el.offsetWidth; el.classList.add('is-on');
    setTimeout(function () { var x = el.querySelector('.hbk__x, .hbm__x'); x && x.focus({ preventScroll: true }); }, 60);
  }
  function close(el) {
    if (!el || el.hidden) return; el.classList.remove('is-on'); lock(false);
    setTimeout(function () { el.hidden = true; }, reduced ? 0 : 450);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { close(K); close(M); } });
  K.addEventListener('click', function (e) { if (e.target.closest('[data-hbk-close]')) close(K); });

  /* ---------- Panier ---------- */
  var cart = null, recos = null, recoFor = null;
  function freeBlock(total) {
    var box = K.querySelector('[data-hbk-free]'), txt = K.querySelector('[data-hbk-free-txt]'), bar = K.querySelector('[data-hbk-bar]');
    if (!C.free) { box.hidden = true; return; }
    var left = C.free - total, pct = Math.max(4, Math.min(100, total / C.free * 100));
    bar.style.width = pct + '%';
    var was = box.classList.contains('is-done');
    if (left <= 0) { txt.innerHTML = '<strong>Livraison offerte ✓</strong>'; box.classList.add('is-done'); if (!was && navigator.vibrate) try { navigator.vibrate(15); } catch (x) {} }
    else { txt.innerHTML = 'Plus que <strong>' + money(left) + '</strong> pour la livraison offerte'; box.classList.remove('is-done'); }
  }
  function render() {
    var c = cart; if (!c) return;
    K.querySelector('[data-hbk-count]').textContent = c.item_count;
    freeBlock(c.total_price);
    if (!c.item_count) {
      foot.hidden = true;
      body.innerHTML = '<div class="hbk__empty"><p>Votre panier est vide</p><a href="' + (C.fallback || '/collections/all') + '">Voir les best-sellers</a></div>';
      return;
    }
    foot.hidden = false;
    K.querySelector('[data-hbk-total]').textContent = money(c.total_price);
    var html = c.items.map(function (it, i) {
      var opts = (it.options_with_values || []).filter(function (o) { return o.value !== 'Default Title'; }).map(function (o) { return esc(o.value); }).join(' · ');
      var sale = it.original_line_price > it.final_line_price;
      var disc = (it.line_level_discount_allocations || []).map(function (d) { return esc(d.discount_application && d.discount_application.title || ''); }).filter(Boolean).join(', ');
      return '<div class="hbk__ln" style="--i:' + i + '" data-key="' + it.key + '">' +
        '<a class="hbk__img" href="' + it.url + '">' + (it.image ? '<img alt="" loading="lazy" src="' + img(it.image, 240) + '">' : '') + '</a>' +
        '<div><a class="hbk__t" href="' + it.url + '">' + esc(it.product_title) + '</a>' + (opts ? '<p class="hbk__v">' + opts + '</p>' : '') +
        '<div class="hbk__row"><div class="hbk__q"><button type="button" data-q="-1" aria-label="Retirer un">−</button><span>' + it.quantity + '</span><button type="button" data-q="1" aria-label="Ajouter un">+</button></div>' +
        '<div class="hbk__pr' + (sale ? ' is-sale' : '') + '"><span>' + money(it.final_line_price) + '</span>' + (sale ? '<s>' + money(it.original_line_price) + '</s>' : '') + '</div></div>' +
        (disc ? '<p class="hbk__disc">' + disc + '</p>' : '') +
        '<button type="button" class="hbk__rm" data-rm>Supprimer</button></div></div>';
    }).join('');
    html += '<div class="hbk__up" data-hbk-up hidden><h3>' + (c.total_price < C.free ? 'Pour atteindre la livraison offerte' : 'Complétez votre look') + '</h3><div class="hbk__ups" data-hbk-ups></div></div>';
    body.innerHTML = html;
    upsell();
  }
  function load() { return json(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (c) { cart = c; render(); bubble(); return c; }); }
  function bubble() {
    nativeFetch(root + '?sections=cart-icon-bubble').then(function (r) { return r.json(); }).then(function (s) {
      var b = document.getElementById('cart-icon-bubble'); if (!b || !s['cart-icon-bubble']) return;
      var t = document.createElement('div'); t.innerHTML = s['cart-icon-bubble']; var inn = t.querySelector('.shopify-section'); b.innerHTML = inn ? inn.innerHTML : t.innerHTML;
    }).catch(function () {});
  }
  function change(key, qty, ln) {
    if (ln) ln.classList.add('is-busy');
    return json(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (c) { if (c.status) throw new Error(c.description); cart = c; render(); bubble(); })
      .catch(function () { if (ln) ln.classList.remove('is-busy'); load(); });
  }
  body.addEventListener('click', function (e) {
    var ln = e.target.closest('[data-key]');
    if (ln) {
      var it = cart.items.filter(function (x) { return x.key === ln.dataset.key; })[0]; if (!it) return;
      var q = e.target.closest('[data-q]');
      if (q) { change(it.key, Math.max(0, it.quantity + (+q.dataset.q)), ln); return; }
      if (e.target.closest('[data-rm]')) { ln.classList.add('is-out'); setTimeout(function () { change(it.key, 0); }, reduced ? 0 : 300); return; }
    }
    var pl = e.target.closest('[data-plus]');
    if (pl) {
      var u = pl.closest('.hbk__u'), p = recos[+u.dataset.i];
      var av = p.variants.filter(function (v) { return v.available; });
      if (av.length === 1) { addVariant(av[0].id, pl); return; }
      u.classList.toggle('is-open'); return;
    }
    var ov = e.target.closest('[data-vid]'); if (ov) addVariant(ov.dataset.vid, ov);
  });
  function addVariant(id, btn) {
    btn.style.opacity = '.5';
    nativeFetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +id, quantity: 1 }] }) })
      .then(function (r) { return r.json(); }).then(function (r) { if (r.status) throw 0; if (navigator.vibrate) try { navigator.vibrate(10); } catch (x) {} return load(); })
      .catch(function () { btn.style.opacity = ''; });
  }
  // Suggestions : produits complémentaires Shopify, sinon produits liés ; on privilégie ceux qui font passer le seuil de livraison offerte
  function upsell() {
    var wrap = body.querySelector('[data-hbk-up]'); if (!wrap || !cart.items.length) return;
    var pid = cart.items[0].product_id, inCart = {};
    cart.items.forEach(function (i) { inCart[i.product_id] = 1; });
    var go = function (list) {
      recos = list.filter(function (p) { return !inCart[p.id] && p.available; });
      var gap = C.free - cart.total_price;
      if (gap > 0) recos.sort(function (a, b) { var A = a.price >= gap, B = b.price >= gap; return A === B ? a.price - b.price : (A ? -1 : 1); });
      recos = recos.slice(0, 4);
      if (!recos.length) return;
      wrap.querySelector('[data-hbk-ups]').innerHTML = recos.map(function (p, i) {
        var src = p.featured_image || (p.images && p.images[0]);
        var opts = p.variants.filter(function (v) { return v.available; }).slice(0, 8).map(function (v) { return '<button type="button" data-vid="' + v.id + '">' + esc(v.title === 'Default Title' ? 'Ajouter' : v.title) + '</button>'; }).join('');
        return '<div class="hbk__u" style="--i:' + i + '" data-i="' + i + '"><a href="' + p.url + '"><span class="hbk__img">' + (src ? '<img alt="" loading="lazy" src="' + img(src, 300) + '">' : '') + '</span><p>' + esc(p.title) + '</p><small>' + money(p.price) + '</small></a>' +
          '<button type="button" class="hbk__plus" data-plus aria-label="Ajouter ' + esc(p.title) + '">+</button><div class="hbk__opts">' + opts + '</div></div>';
      }).join('');
      wrap.hidden = false;
    };
    if (recoFor === pid && recos) { go(recos.concat([])); return; }
    var get = function (intent) { return json(root + 'recommendations/products.json?product_id=' + pid + '&limit=8&intent=' + intent).then(function (d) { return d.products || []; }).catch(function () { return []; }); };
    get('complementary').then(function (a) { return a.length >= 3 ? a : get('related').then(function (b) { var s = {}; return a.concat(b).filter(function (p) { if (s[p.id]) return false; s[p.id] = 1; return true; }); }); })
      .then(function (l) { recoFor = pid; go(l); });
  }
  window.HBCart = { open: function () { open(K); load(); }, refresh: load };

  // L'icône panier ouvre le tiroir (au lieu de la page panier ou de l'ancien tiroir du thème)
  document.addEventListener('click', function (e) {
    var a = e.target.closest('#cart-icon-bubble, a[href$="/cart"].header__icon');
    if (a && !e.metaKey && !e.ctrlKey) { e.preventDefault(); e.stopImmediatePropagation(); window.HBCart.open(); }
  }, true);
  // Tout ajout au panier sur le site (fiche, collection, portant, best-sellers…) ouvre le nouveau tiroir
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nativeFetch(input, init);
    if (/\/cart\/add(\.js)?(\?|$)/.test(url)) p.then(function (r) { if (r.ok) setTimeout(function () { open(K); load(); }, 120); }).catch(function () {});
    return p;
  };
  // Neutralise l'ancien tiroir du thème s'il est appelé
  function tame() {
    var d = document.querySelector('cart-drawer'); if (!d) return;
    d.renderContents = function () {}; d.open = function () { window.HBCart.open(); };
  }
  if (customElements && customElements.whenDefined) customElements.whenDefined('cart-drawer').then(tame); tame();
  // Swipe vers la droite pour fermer (mobile)
  var pnl = K.querySelector('.hbk__p'), x0 = null;
  pnl.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
  pnl.addEventListener('touchmove', function (e) { if (x0 === null) return; var dx = e.touches[0].clientX - x0; if (dx > 0) pnl.style.transform = 'translateX(' + dx + 'px)'; }, { passive: true });
  pnl.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null; pnl.style.transform = ''; if (dx > 90) close(K); });

  /* ---------- Menu mobile ---------- */
  if (M) {
    document.addEventListener('click', function (e) {
      var s = e.target.closest('summary.header__icon--menu, .header__icon--menu');
      if (s && matchMedia('(max-width: 989px)').matches) { e.preventDefault(); e.stopImmediatePropagation(); var d = s.closest('details'); if (d) d.removeAttribute('open'); open(M); }
    }, true);
    M.addEventListener('click', function (e) { if (e.target.closest('[data-hbm-close]')) close(M); else if (e.target.closest('a[href]')) close(M); });
    // un seul sous-menu ouvert à la fois
    M.querySelectorAll('.hbm__it details').forEach(function (d) { d.addEventListener('toggle', function () { if (d.open) M.querySelectorAll('.hbm__it details[open]').forEach(function (o) { if (o !== d) o.open = false; }); }); });
  }
})();
